import { svg } from "@opentiny/vue-common";
var render = function render2() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24",
      "xml:space": "preserve"
    }
  }, _vm.$listeners), [_c("path", {
    staticClass: "down_svg__st0",
    attrs: {
      "d": "M2 6h20L12 19z"
    }
  })]);
};
var Down = {
  render
};
var index = function index2() {
  return svg({
    name: "IconDown",
    component: Down
  })();
};
export {
  index as default
};
